import React, { RefObject, useRef } from 'react';
import { WizardContent } from '../../wizard';
import { WizardContentProps } from '../../types';
import wizardStyles from '../../wizard.module.scss';
import { SolarStorageChart } from './solar-storage-chart';
import { SliderVisual } from '@components/slider-visual/slider-visual';
import { useIsAnswered } from '@hooks/use-is-answered';
import { QuestionCard } from '@components/question-card/question-card';

export const SolarStorageWizardContent: React.FC<
  WizardContentProps<PvWizardResultSectionSolarStorage> & {
    formModals?: {
      roofAge: PvWizardContent['disclaimerText'];
      roofMaterial: PvWizardContent['disclaimerText'];
    };
    modalRef?: RefObject<HTMLDivElement>;
  }
> = ({
  questions,
  onAnswerUpdated,
  nextStep,
  previousStep,
  wizardState,
  result,
  sectionKey,
  sectionInfo,
  formModals,
  modalRef
}) => {
  const ref = useRef<HTMLDivElement>(null);
  const isQuestionAnswered = useIsAnswered<PvWizardQuestion>({
    questions,
    answers: wizardState.answers,
    activeSlide: wizardState.activeSlide
  });

  return (
    <WizardContent
      hideItemTop={wizardState.activeSlideKey === 'roofDetails'}
      classNameItemTop={wizardStyles.wizardItemTop}
      itemTop={
        <SliderVisual
          summaryLabel={'geschätzter Eigenverbrauch'}
          summaryValue={`${result?.summary.value || 0} kWh`}
          subline={`von ${result?.summary.subline || 0} kWh Energiebedarf pro Jahr`}
          sectionInfo={sectionInfo}
          modalRef={ref}
          containerAsRow
        >
          <SolarStorageChart result={result} />
        </SliderVisual>
      }
      itemBottom={
        <QuestionCard
          sectionKey={sectionKey}
          activeQuestion={questions[wizardState.activeSlide]}
          onAnswerUpdated={onAnswerUpdated}
          previousStep={previousStep}
          nextStep={nextStep}
          wizardState={wizardState}
          showNextButton={isQuestionAnswered}
          showBackButton={sectionKey !== 'startScreen'}
          formModals={formModals}
          modalRef={modalRef}
        />
      }
      ref={ref}
    />
  );
};
